import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {ProductLineSearchPageComponent} from "./product-line/product-line-search-page/product-line-search-page.component";
import {ExtraSearchPageComponent} from "./extras/extra-search-page/extra-search-page.component";
import {CompositeProductSearchPageComponent} from "./composite-product/composite-product-search-page/composite-product-search-page.component";
import {PreparationModifierSearchPageComponent} from "./preparation-modifier/preparation-modifier-search-page/preparation-modifier-search-page.component";
import {SizeGroupSearchPageComponent} from "./size-group/size-group-search-page/size-group-search-page.component";
import {SizeGroupRelationSearchPageComponent} from "./size-group-relation/size-group-relation-search-page/size-group-relation-search-page.component";
import {PlgSearchPageComponent} from "./plg/plg-search-page/plg-search-page.component";
import {ProductContainerSearchPageComponent} from "./product-container/product-container-search-page/product-container-search-page.component";
import {ProductLineEditPageComponent} from "./product-line/product-line-edit-page/product-line-edit-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {StockSharedModule} from "../stock/stock.shared.module";
import {CatalogueSharedModule} from "./catalogue.shared.module";
import {SystemSharedModule} from "../system/system.shared.module";
import {PlgEditPageComponent} from "./plg/plg-edit-page/plg-edit-page.component";
import {SellableSearchPageComponent} from "./sellable/sellable-search-page/sellable-search-page.component";
import {ExtraEditPageComponent} from "./extras/extra-edit-page/extra-edit-page.component";
import {CompositeProductEditPageComponent} from "./composite-product/composite-product-edit-page/composite-product-edit-page.component";
import {SellableEditPriceLevelsComponent} from "./sellable/sellable-edit-price-levels/sellable-edit-price-levels.component";
import {PreparationModifierEditPageComponent} from "./preparation-modifier/preparation-modifier-edit-page/preparation-modifier-edit-page.component";
import {CompositeProductComponentEditLinkColumnComponent} from "./composite-product/controls/composite-product-component-edit-link-column.component";
import {CompositeProductComponentSingleSelectEditControlComponent} from "./composite-product/controls/composite-product-component-single-select-edit-control.component";
import {ProductContainerEditPageComponent} from "./product-container/product-container-edit-page/product-container-edit-page.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {CustomersSharedModule} from "../customers/customers.shared.module";
import {SizeGroupEditPageComponent} from "./size-group/size-group-edit-page/size-group-edit-page.component";
import {SizeGroupRelationEditPageComponent} from "./size-group-relation/size-group-relation-edit-page/size-group-relation-edit-page.component";
import {SellableSizeColumnComponent} from "./sellable-size/controls/sellable-size-column.component";
import {ProductPluReportPageComponent} from "./reports/productplu/product-plu-report-page.component";
import {SellableEditImageryComponent} from "./sellable/sellable-edit-imagery/sellable-edit-imagery.component";
import {CategorySearchPageComponent} from "./category/category-search-page/category-search-page.component";
import {CategoryEditPageComponent} from "./category/category-edit-page/category-edit-page.component";
import {ProductPriceLevelReportPageComponent} from "./reports/productpricelevel/product-price-level-report-page.component";
import {ProductCostingBomReportPageComponent} from "./reports/productcostingbom/product-costing-bom-report-page.component";
import {SellableEditBarcodesComponent} from "./sellable/sellable-edit-barcodes/sellable-edit-barcodes.component";
import {ProductWastageReportPageComponent} from "./reports/productwastage/product-wastage-report-page.component";
import {EmployeeSharedModule} from "../employee/employee.shared.module";
import {PosSharedModule} from "../pos/pos.shared.module";
import {ProductBarcodeReportComponent} from "./reports/product-barcode-report/product-barcode-report.component";
import {ProductBarcodeSearchPageComponent} from "./product-barcode/product-barcode-search-page/product-barcode-search-page.component";
import {ReportsSharedModule} from "../reports/reports.shared.module";
import {PreparationModifierValuesSearchPageComponent} from "./preparation-modifier/preparation-modifier-values-search-page/preparation-modifier-values-search-page.component";
import {SizeGroupValuesSearchPageComponent} from "./size-group/size-group-values-search-page/size-group-values-search-page.component";
import {DocketSelectorAuditReportPageComponent} from "./reports/docketselectoraudit/docket-selector-audit-report-page.component";
import {CategoryMoveSearchActionComponent} from "./category/category-search-page/category-move-search-action.component";
import {CategoryMoveModalComponent} from "./category/category-search-page/category-move-modal.component";
import {DietaryIndicatorSearchPageComponent} from "./dietary-indicator/dietary-indicator-search-page/dietary-indicator-search-page.component";
import {
    DietaryIndicatorEditPageComponent
} from "./dietary-indicator/dietary-indicator-edit-page/dietary-indicator-edit-page.component";
import {OrderProcessingSharedModule} from "../order-processing/order-processing.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        ReportsSharedModule,
        CustomObjectSharedModule,
        PricingSharedModule,
        StockSharedModule,
        CatalogueSharedModule,
        SystemSharedModule,
        CustomersSharedModule,
        EmployeeSharedModule,
        PosSharedModule,
        OrderProcessingSharedModule
    ],
    declarations: [
        ProductLineSearchPageComponent,
        ProductLineEditPageComponent,
        SellableEditImageryComponent,
        ExtraSearchPageComponent,
        ProductBarcodeSearchPageComponent,
        ExtraEditPageComponent,
        CompositeProductSearchPageComponent,
        PreparationModifierSearchPageComponent,
        PreparationModifierValuesSearchPageComponent,
        SellableSearchPageComponent,
        SizeGroupSearchPageComponent,
        SizeGroupValuesSearchPageComponent,
        SizeGroupRelationSearchPageComponent,
        PlgSearchPageComponent,
        PlgEditPageComponent,
        ProductContainerSearchPageComponent,
        CompositeProductEditPageComponent,
        CompositeProductComponentEditLinkColumnComponent,
        CompositeProductComponentSingleSelectEditControlComponent,
        SellableEditPriceLevelsComponent,
        SellableEditBarcodesComponent,
        PreparationModifierEditPageComponent,
        ProductContainerEditPageComponent,
        SizeGroupEditPageComponent,
        SizeGroupRelationEditPageComponent,
        SellableSizeColumnComponent,
        ProductPluReportPageComponent,
        DocketSelectorAuditReportPageComponent,
        CategorySearchPageComponent,
        CategoryMoveSearchActionComponent,
        CategoryMoveModalComponent,
        CategoryEditPageComponent,
        ProductPriceLevelReportPageComponent,
        ProductCostingBomReportPageComponent,
        ProductBarcodeReportComponent,
        ProductWastageReportPageComponent,
        DietaryIndicatorSearchPageComponent,
        DietaryIndicatorEditPageComponent
    ],
    exports: [
        ProductLineSearchPageComponent,
        ProductLineEditPageComponent,
        SellableEditImageryComponent,
        ExtraSearchPageComponent,
        ProductBarcodeSearchPageComponent,
        ExtraEditPageComponent,
        CompositeProductSearchPageComponent,
        PreparationModifierSearchPageComponent,
        PreparationModifierValuesSearchPageComponent,
        SellableSearchPageComponent,
        SizeGroupSearchPageComponent,
        SizeGroupValuesSearchPageComponent,
        SizeGroupRelationSearchPageComponent,
        PlgSearchPageComponent,
        PlgEditPageComponent,
        ProductContainerSearchPageComponent,
        CompositeProductEditPageComponent,
        CompositeProductComponentEditLinkColumnComponent,
        CompositeProductComponentSingleSelectEditControlComponent,
        SellableEditPriceLevelsComponent,
        SellableEditBarcodesComponent,
        PreparationModifierEditPageComponent,
        ProductContainerEditPageComponent,
        SizeGroupEditPageComponent,
        SizeGroupRelationEditPageComponent,
        SellableSizeColumnComponent,
        ProductPluReportPageComponent,
        DocketSelectorAuditReportPageComponent,
        CategorySearchPageComponent,
        CategoryMoveSearchActionComponent,
        CategoryMoveModalComponent,
        CategoryEditPageComponent,
        ProductPriceLevelReportPageComponent,
        ProductCostingBomReportPageComponent,
        ProductBarcodeReportComponent,
        ProductWastageReportPageComponent,
        DietaryIndicatorSearchPageComponent,
        DietaryIndicatorEditPageComponent
    ]
})
export class CatalogueModule {
}
